import React from 'react'
import X5_A from '../../assets/X5/X5-A.png'
import X5_B from '../../assets/X5/X5-B.png'
import X5_C from '../../assets/X5/X5-C.png'
import X5_D from '../../assets/X5/X5-D.png'
import X5_E from '../../assets/X5/X5-E.png'
import X5_F from '../../assets/X5/X5-F.png'
class X5Model extends React.Component {
  state = {
    numList: [
      { value: 1, type: 'X5_A', active: true, top: 30, left: 122 },
      { value: 2, type: 'X5_A', active: true, top: 30, left: 150 },
      { value: 3, type: 'X5_A', active: true, top: 55, left: 155 },
      { value: 4, type: 'X5_A', active: true, top: 83, left: 150 },
      { value: 5, type: 'X5_A', active: true, top: 86, left: 122 },
      { value: 6, type: 'X5_A', active: true, top: 83, left: 92 },
      { value: 7, type: 'X5_A', active: true, top: 55, left: 90 },
      { value: 8, type: 'X5_A', active: true, top: 30, left: 92 },
      { value: 9, type: 'X5_B', active: false, top: 120, left: 167 },
      { value: 10, type: 'X5_B', active: false, top: 114, left: 190 },
      { value: 11, type: 'X5_B', active: false, top: 139, left: 200 },
      { value: 12, type: 'X5_B', active: false, top: 166, left: 202 },
      { value: 13, type: 'X5_B', active: false, top: 173, left: 175 },
      { value: 14, type: 'X5_B', active: false, top: 180, left: 148 },
      { value: 15, type: 'X5_B', active: false, top: 154, left: 136 },
      { value: 16, type: 'X5_B', active: false, top: 125, left: 135 },
      { value: 17, type: 'X5_C', active: false, top: 120, left: 74 },
      { value: 18, type: 'X5_C', active: false, top: 125, left: 100 },
      { value: 19, type: 'X5_C', active: false, top: 153, left: 99 },
      { value: 20, type: 'X5_C', active: false, top: 179, left: 88 },
      { value: 21, type: 'X5_C', active: false, top: 172, left: 62 },
      { value: 22, type: 'X5_C', active: false, top: 166, left: 33 },
      { value: 23, type: 'X5_C', active: false, top: 140, left: 36 },
      { value: 24, type: 'X5_C', active: false, top: 114, left: 46 },
      { value: 25, type: 'X5_D', active: false, top: 100, left: 24 },
      { value: 26, type: 'X5_D', active: false, top: 68, left: 36 },
      { value: 27, type: 'X5_D', active: false, top: 41, left: 57 },
      { value: 28, type: 'X5_E', active: false, top: 41, left: 180 },
      { value: 29, type: 'X5_E', active: false, top: 68, left: 198 },
      { value: 30, type: 'X5_E', active: false, top: 100, left: 210 },
      { value: 31, type: 'X5_F', active: false, top: 210, left: 86 },
      { value: 32, type: 'X5_F', active: false, top: 210, left: 119 },
      { value: 33, type: 'X5_F', active: false, top: 210, left: 152 },
    ],
  }
  handleClick = (img, type) => {
    this.props.toggleArea(img, type)
    let numList = this.state.numList
    numList.forEach((item) => {
      if (item.type == type) {
        item.active = true
      } else {
        item.active = false
      }
    })

    this.setState({
      numList,
    })
  }

  render() {
    const { toggleArea, currentImg } = this.props
    return (
      <div className='areaFather'>
        <div
          onClick={() => this.handleClick(X5_A, 'X5_A')}
          className='wrapA'></div>
        <div
          onClick={() => this.handleClick(X5_B, 'X5_B')}
          className='wrapB'></div>
        <div
          onClick={() => this.handleClick(X5_C, 'X5_C')}
          className='wrapC'></div>
        <div
          onClick={() => this.handleClick(X5_D, 'X5_D')}
          className='wrapD'></div>
        <div
          onClick={() => this.handleClick(X5_E, 'X5_E')}
          className='wrapE'></div>
        <div
          onClick={() => this.handleClick(X5_F, 'X5_F')}
          className='wrapF'></div>
        <img style={{ display: 'block', marginTop: 4 }} src={currentImg}></img>
        {this.state.numList.map((item) => {
          return (
            <div
              key={item.value}
              style={{
                top: item.top,
                left: item.left,
              }}
              className={'aisleNum ' + (!item.active ? 'active' : '')}>
              {item.value}
            </div>
          )
        })}
      </div>
    )
  }
}

export default X5Model
